export default "__VITE_ASSET__MtDVaTKY__"